import { render, staticRenderFns } from "./MenuOptions.vue?vue&type=template&id=00521d32&scoped=true"
import script from "./MenuOptions.vue?vue&type=script&lang=js"
export * from "./MenuOptions.vue?vue&type=script&lang=js"
import style0 from "./MenuOptions.vue?vue&type=style&index=0&id=00521d32&prod&scoped=true&lang=css"
import style1 from "./MenuOptions.vue?vue&type=style&index=1&id=00521d32&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00521d32",
  null
  
)

export default component.exports